import React, { useState, useEffect, useContext, useMemo } from 'react';


import { DataContext } from '../../../init/getData';
import { PosCartContext } from '../../../init/posCartData';
import { DynamicModalContext } from '../../../init/dynamicModals';

import { Modal, Col, Form, Row, DropdownButton, Dropdown, InputGroup, Card } from 'react-bootstrap';
import { Button } from 'antd';

import AsyncSelect from 'react-select/async';
import AsyncCreatableSelect from 'react-select/creatable';

import toast from 'react-hot-toast';
import KeyPad from '../../../components/keyPad/keyPad';
import { FaUserPlus } from "react-icons/fa6";

import Loader from '../../../components/loader/loader';
import CustomerForm from '../../../salesTab/customer/customerForm';



function CustomerModal(props) {

  const { showModal, toggleModal, title, selectedTab, } = props;

  const { settingData, customerAccountData, refData, companyId, customerAccountOptions, loadCustomerAccountOptions } = useContext(DataContext);
  const { tabData, setTabData, setJournalVoucher } = useContext(PosCartContext);
  const { openAddCustomerModal, addedCustomerId } = useContext(DynamicModalContext);

  const [loadingEffect, setLoadingEffect] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);



  const cart = tabData[selectedTab].cart;
  const journalVoucher = tabData[selectedTab].journalVoucher;



  useEffect(() => {
    setInputValue("");
  }, [showModal]);


  useEffect(() => {
    if (addedCustomerId) {
      let updatedJv = { ...journalVoucher };
      updatedJv.accountId = addedCustomerId;
      setJournalVoucher(updatedJv, selectedTab)
    }
  }, [addedCustomerId]);


  // handle select change
  const handleSelectChange = (selectedOption, name) => {
    let updatedJv = { ...journalVoucher };
    updatedJv.accountId = selectedOption?.value || null;

    setJournalVoucher(updatedJv, selectedTab)
  };

  const closeModal = () => {
    toggleModal();
  }

  const selectedCustomer = useMemo(
    () => customerAccountOptions?.find(option => option.value === journalVoucher.accountId),
    [customerAccountOptions, journalVoucher.accountId]
  );

  return (
    <Modal show={showModal} onHide={toggleModal} backdrop='static'>
      <Modal.Header style={{ background: "#1d7790" }}>
        <Modal.Title style={{ color: "white" }}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>

        {isLoading &&
          <Loader />
        }

        {!isLoading &&
          <Row className="mb-4" style={{ marginTop: '4vh' }}>

            <Col>
              <AsyncSelect
                cacheOptions
                isClearable={true}
                loadOptions={loadCustomerAccountOptions}
                defaultOptions={[]}
                onChange={(e) => handleSelectChange(e, 'accountId')}
                value={selectedCustomer}
                noOptionsMessage={() => 'type to view'}
                autoFocus
                onKeyDown={(e) => { if (e.key === 'Enter') { closeModal() } }}
              />
            </Col>

            <Col md={2}>
              <FaUserPlus size={30} style={{ cursor: 'pointer' }} onClick={openAddCustomerModal} />
            </Col>

          </Row>
        }



      </Modal.Body>
      <Modal.Footer>
        <div>
          <Button type="primary" size="large" loading={loadingEffect} onClick={closeModal}
            style={{ marginLeft: '10px', backgroundColor: '#1d7790' }} danger>Done</Button>
        </div>
      </Modal.Footer>

    </Modal>

  );
}

export default CustomerModal;
